// Under the PCom switch (Stroke's Scenario section): what the chosen anatomy and arm come to, from the loaded
// tissue run's own growth table (features/pcom.ts). It follows the run the switch resolves, so flipping the
// switch rewrites it; nothing here is typed in from the handoff.

import { useAtlas } from '../app/store.ts';
import { openedSlot } from '../app/sims.ts';
import { useLoaded } from '../ui/hooks.ts';
import { outcomeLine, outcomeOf } from './pcom.ts';

export function PcomOutcome() {
  const pcom = useAtlas((s) => s.stroke.pcom);
  const hours = useAtlas((s) => s.stroke.thrombectomyH);
  const main = useAtlas((s) => (s.sims.scenario === s.scenario && s.sims.status === 'ready' ? s.sims.slots.find((x) => x.slot === 'main')?.path : undefined) ?? null);
  const o = main ? openedSlot('main') : undefined;
  const sim = o?.format === 'hemo' && o.header.kind === 'tissue-fate' ? o.sim : null;
  const table = useLoaded(() => (sim ? sim.growth() : null), [main, sim]);
  const out = table.value ? outcomeOf(table.value) : null;
  if (!out) return null;
  return (
    <p className="live-hint live-outcome" title="From the run’s own growth table (growth.csv): native mL at its last row">
      {outcomeLine(out, pcom, hours)}
    </p>
  );
}
